var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-menu__child-item"},[_c('a',{staticClass:"c-menu__child-link",class:_vm.linkingMode,attrs:{"href":_vm.linkUrl}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }